export const TRANSACTION_SETTINGS_ATTRIBUTES_CONSTANT = {
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  name: {
    type: 'text',
    key: 'name',
    label: 'Name',
  },
  value: {
    type: 'text',
    key: 'value',
    label: 'Value',
  },
  description: {
    type: 'text',
    key: 'description',
    label: 'Description',
  },
  srcCountry: {
    type: 'select',
    key: 'src_country',
    label: 'Source Country',
  },
  destCountry: {
    type: 'select',
    key: 'dest_country',
    label: 'Destination Country',
  },
} as const;

export const TRANSACTION_SETTINGS = [
  { name: 'Source of Income', code: 'source_of_income_codes' },
  { name: 'Purpose', code: 'remittance_purpose_codes' },
  { name: 'Transfer Type', code: 'transfer_types' },
  { name: 'Service Level', code: 'service_level_delivery_speed_codes' },
  { name: 'Payment Method', code: 'payment_method_codes' },
];
